import React from 'react'

const Memos = () => {
  return (
    <div className='mx-auto p-4'>
      Memos
    </div>
  )
}

export default Memos
